/** Copy for the left navigation. */
export const LEFT_NAV_CONFIG = {
  support: {
    // Toast Messages
    toasts: {
      copied: {
        title: 'Support email copied:',
        text: (email: string) => email,
      },
    },
  },
} as const;
